import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ProductCaptureData } from '../../model/interfaces/product-capture.interface';
import { TimelineData } from '../../model/interfaces/timeline-data.interface';
import { OverviewService } from '../../services/overview.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  @Input() productId: number = null;
  @Input() productDetailData: ProductCaptureData;
  @Input() loading: boolean;
  @Input() rows;
  @Output() goToDocuments: EventEmitter<void> = new EventEmitter();
  timelineData: Array<TimelineData>;

  columns;
  schedules = [];

  messages = {
    emptyMessage: 'No schedules found.',
    totalMessage: 'Total',
  };

  sortOrder = [
    {
      prop: 'period',
    },
  ];

  constructor(private overviewService: OverviewService) {}

  ngOnInit(): void {
    this.schedules = [...this.rows];

    this.timelineData = this.overviewService.getLifecycleTimelineData(
      this.productDetailData
    );

    this.columns = [
      {
        name: 'Period',
        prop: 'period',
        resizeable: false,
        draggable: false,
        minWidth: 100,
        maxWidth: 100,
        canAutoResize: true,
        flexGrow: 1,
        cellTemplate: 'numberTemplate',
      },
      {
        name: 'Cpn Fixing Date',
        prop: 'rateDeterminationDate',
        resizeable: false,
        draggable: false,
        minWidth: 100,
        canAutoResize: true,
        flexGrow: 1,
        cellTemplate: 'dateTemplateNoGmt',
      },
      {
        name: 'Cpn Start Date',
        prop: 'accrualPeriodStart',
        resizeable: false,
        draggable: false,
        minWidth: 100,
        canAutoResize: true,
        flexGrow: 1,
        cellTemplate: 'dateTemplateNoGmt',
      },
      {
        name: 'Cpn End Date',
        prop: 'accrualPeriodEnd',
        resizeable: false,
        draggable: false,
        minWidth: 100,
        canAutoResize: true,
        flexGrow: 1,
        cellTemplate: 'dateTemplateNoGmt',
      },
      {
        name: 'Cpn Payment Date',
        prop: 'adjustedPaymentDate',
        resizeable: false,
        draggable: false,
        minWidth: 100,
        canAutoResize: true,
        flexGrow: 1,
        cellTemplate: 'dateTemplateNoGmt',
      },
      {
        name: 'Coupon Type',
        prop: 'type',
        resizeable: false,
        draggable: false,
        minWidth: 100,
        canAutoResize: true,
        flexGrow: 1,
        cellTemplate: 'titlecaseTemplate',
      },
    ];
  }

  openDocuments(): void {
    this.goToDocuments.emit();
  }
}
